/**
 * Ashrafie Query Keys
 *
 * Hierarchical TanStack Query key factory. Enables targeted cache invalidation
 * after mutations (e.g. invalidate account + history after a successful redeem).
 *
 * @module lib/api/ashrafie/queryKeys
 */

import type { AshrafieRedemptionStatus } from './types';

export const ashrafieKeys = {
  all: ['ashrafie'] as const,

  account: {
    all: () => [...ashrafieKeys.all, 'account'] as const,
    snapshot: () => [...ashrafieKeys.account.all(), 'snapshot'] as const,
    history: (limit?: number) =>
      [...ashrafieKeys.account.all(), 'history', { limit }] as const,
    badges: () => [...ashrafieKeys.account.all(), 'badges'] as const,
  },

  passport: {
    all: () => [...ashrafieKeys.all, 'passport'] as const,
  },

  redemptions: {
    all: () => [...ashrafieKeys.all, 'redemptions'] as const,
    list: (filters?: { limit?: number; status?: AshrafieRedemptionStatus }) =>
      [...ashrafieKeys.redemptions.all(), 'list', filters ?? {}] as const,
    detail: (id: string) =>
      [...ashrafieKeys.redemptions.all(), 'detail', id] as const,
  },

  badges: {
    all: () => [...ashrafieKeys.all, 'badges'] as const,
    catalog: () => [...ashrafieKeys.badges.all(), 'catalog'] as const,
  },

  referral: {
    all: () => [...ashrafieKeys.all, 'referral'] as const,
    summary: () => [...ashrafieKeys.referral.all(), 'summary'] as const,
  },

  reputation: {
    all: () => [...ashrafieKeys.all, 'reputation'] as const,
    mine: () => [...ashrafieKeys.reputation.all(), 'mine'] as const,
    public: (handle: string) =>
      [...ashrafieKeys.reputation.all(), 'public', handle] as const,
  },

  trophies: {
    all: () => [...ashrafieKeys.all, 'trophies'] as const,
    mine: () => [...ashrafieKeys.trophies.all(), 'mine'] as const,
    catalog: () => [...ashrafieKeys.trophies.all(), 'catalog'] as const,
  },

  stamps: {
    all: () => [...ashrafieKeys.all, 'stamps'] as const,
    mine: () => [...ashrafieKeys.stamps.all(), 'mine'] as const,
  },
} as const;
